
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/isms",
      function () {
        return require("private-next-pages/isms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/isms"])
      });
    }
  